const SLACK_CHANNEL = /^https:\/\/([a-z0-9-]+\.slack\.com\/archives\/[A-Z0-9]+|app\.slack\.com\/client\/[A-Z0-9]+\/[A-Z0-9]+)(\/\S*)?$/;

export function isSlackChannelLink(value: string): boolean {
  return SLACK_CHANNEL.test(value.trim());
}

export function toSlackChannelLabel(value: string): string {
  const channel = value.trim();
  const archived = channel.split("/archives/")[1];
  if (archived) return archived.split("/")[0];
  return channel.match(/app\.slack\.com\/client\/[^/]+\/([^/]+)/)?.[1] ?? value;
}
